import { render, staticRenderFns } from "./packagesToast.vue?vue&type=template&id=ab4eba58&scoped=true&"
import script from "./packagesToast.vue?vue&type=script&lang=js&"
export * from "./packagesToast.vue?vue&type=script&lang=js&"
import style0 from "./packagesToast.vue?vue&type=style&index=0&id=ab4eba58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4eba58",
  null
  
)

export default component.exports